import React from "react";
import { Autocomplete, TextField, CircularProgress } from "@mui/material";
import { formatTickerSymbolDisplay } from "../utility";
import { parseTickerSymbolStockInput } from "../Popup/orderDialogHelpers";

const defaultLabelProps = { shrink: true, sx: { fontWeight: 600 } };

/** Shared ticker Autocomplete (symbol + optional stock leg). */
const TickerSymbolAutocomplete = ({
  uniqueTickers,
  ticker,
  stock,
  setFormData,
  label = "Ticker",
  placeholder,
  required = true,
  inputLabelProps = defaultLabelProps,
  patsMode = false,
  patsOptions = [],
  patsLoading = false,
  patsHelperText,
}) => {
  if (patsMode) {
    return (
      <Autocomplete
        options={patsOptions}
        value={patsOptions.includes(ticker) ? ticker : null}
        onChange={(event, newValue) => {
          setFormData((prev) => ({
            ...prev,
            ticker: (newValue || "").toUpperCase(),
            stock: "",
          }));
        }}
        freeSolo
        forcePopupIcon
        loading={patsLoading}
        inputValue={ticker}
        onInputChange={(event, newInputValue) => {
          setFormData((prev) => ({
            ...prev,
            ticker: newInputValue.toUpperCase(),
            stock: "",
          }));
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            variant="outlined"
            size="small"
            placeholder={placeholder}
            InputLabelProps={inputLabelProps}
            required={required}
            helperText={patsHelperText}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {patsLoading ? (
                    <CircularProgress color="inherit" size={16} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    );
  }

  return (
    <Autocomplete
      options={uniqueTickers}
      getOptionLabel={(option) =>
        typeof option === "string" ? option : formatTickerSymbolDisplay(option)
      }
      isOptionEqualToValue={(option, value) =>
        option.symbol === value.symbol &&
        (option.stock || "") === (value.stock || "")
      }
      value={
        uniqueTickers.find(
          (row) => row.symbol === ticker && (row.stock || "") === (stock || "")
        ) || null
      }
      onChange={(event, newValue) => {
        if (typeof newValue === "string") {
          setFormData((prev) => ({
            ...prev,
            ticker: newValue.toUpperCase(),
            stock: "",
          }));
          return;
        }
        setFormData((prev) => ({
          ...prev,
          ticker: newValue?.symbol || "",
          stock: newValue?.stock || "",
        }));
      }}
      freeSolo
      inputValue={formatTickerSymbolDisplay({ symbol: ticker, stock })}
      onInputChange={(event, newInputValue) => {
        const { symbol, stock: nextStock } =
          parseTickerSymbolStockInput(newInputValue);
        setFormData((prev) => ({
          ...prev,
          ticker: symbol,
          stock: nextStock,
        }));
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant="outlined"
          size="small"
          placeholder={placeholder}
          InputLabelProps={inputLabelProps}
          required={required}
        />
      )}
    />
  );
};

export default TickerSymbolAutocomplete;
